import { useState, useEffect, useRef } from 'react';
import Sidebar from '@/components/common/Sidebar';
import Header from '@/components/Header';
import { Link, Outlet, useSearchParams } from 'react-router-dom';
import Footer from '@/components/Footer';
import CustomChipsModal from '@/components/CustomChipsModal';
import ChangePasswordModal from '@/components/ChangePassword';
import BottomNavigation from '@/components/BottomNavigation';
import RulesModal from '@/components/RulesModal';
import { Icons } from '@/utils/Icons';
import { useUserInfo } from '@/hooks/useUserInfo';

const MainLayout = () => {
  const [collapse, setCollapse] = useState(true);
  const [searchParams] = useSearchParams();
  const full = searchParams.get('full') === 'true' || false;
  const { loggedIn } = useUserInfo();
  const [showSticky, setShowSticky] = useState(false);
  const lastScrollY = useRef(0);
  const isProfileDrawerOpen = window.location.pathname === '/user';

  useEffect(() => {
    const media = window.matchMedia('(min-width: 1536px)');

    const handleResize = () => {
      setCollapse(!media.matches);
    };

    handleResize();
    media.addEventListener('change', handleResize);

    return () => media.removeEventListener('change', handleResize);
  }, []);

  useEffect(() => {
    if (full) {
      setCollapse(true);
    }
  }, [full]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < lastScrollY.current) {
        // Scrolling UP → show sticky bar
        setShowSticky(true);
      } else {
        // Scrolling DOWN → hide sticky bar
        setShowSticky(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="h-screen text-white">
      <Sidebar collapse={collapse} onToggle={() => setCollapse(!collapse)} />

      <div className={`${collapse ? 'lg:ml-[70px]' : '2xl:ml-[300px] lg:px-[50px]'} px-2 lg:px-4`}>
        <Header collapse={collapse} onToggle={() => setCollapse(!collapse)} />
        <main className="max-lg:mb-[70px]">
          {loggedIn && !isProfileDrawerOpen && (
            <div
              className={`
      lg:hidden grid grid-cols-2 h-[44px] gap-[10px]
      font-bold pb-[5px] bg-[#25252E]
      sticky top-11 z-[999]
      transition-all duration-300 ease-in-out
      ${showSticky ? 'translate-y-0 opacity-100' : '-translate-y-5 opacity-0 pointer-events-none'}
    `}
            >
              <Link
                to="/deposit"
                className="bg-[#13B153] flex items-center justify-center gap-[10px] rounded-sm"
              >
                Deposit <Icons.Wallet />
              </Link>

              <Link
                to="/withdraw"
                className="bg-[#F54C4CCC] flex items-center justify-center gap-[10px] rounded-sm"
              >
                Withdraw <Icons.Wallet />
              </Link>
            </div>
          )}
          <Outlet />
          <Footer />
          {!full && <BottomNavigation />}
          <CustomChipsModal />
          <ChangePasswordModal />
          <RulesModal />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
